const COOKIE_NAME = "pl_access_token";
const COOKIE_DOMAIN = ".promptlayer.com";
const COOKIE_MAX_AGE_SECONDS = 86400;

const isLocalhost = (): boolean => {
  const { hostname } = window.location;
  return hostname === "localhost" || hostname === "127.0.0.1";
};

const getCookieAttributes = (): string => {
  if (isLocalhost()) {
    // On localhost, omit Domain entirely. Browsers reject "Domain=localhost"
    // because it lacks an embedded dot (RFC 6265). Without an explicit Domain,
    // the cookie becomes "host-only" for localhost — and since cookies are NOT
    // port-scoped, it will be sent to all localhost ports (3000, 3001, etc.).
    return `Path=/; SameSite=Lax`;
  }
  return `Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax`;
};

export const setAuthCookie = (token: string): void => {
  document.cookie = `${COOKIE_NAME}=${token}; ${getCookieAttributes()}; Max-Age=${COOKIE_MAX_AGE_SECONDS}`;
};

export const clearAuthCookie = (): void => {
  document.cookie = `${COOKIE_NAME}=; ${getCookieAttributes()}; Max-Age=0`;
};
